import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import AppAnalytics from '../analytics/AppAnalytics';

@customElement('waitlist-cta')
export class WaitlistCta extends LitElement {
  @property({ type: String })
  source = 'homepage_final_cta';

  static styles = css`
    :host {
      display: block;
    }

    .cta-button {
      border: 2px solid transparent;
      background: linear-gradient(135deg, rgba(0, 212, 255, 0.1), rgba(168, 85, 247, 0.1)) padding-box,
                  linear-gradient(135deg, #00d4ff, #a855f7) border-box;
      background-image: linear-gradient(to right, #00ff88, #0ea5e9);
      color: #0a0f1b;
      padding: 1rem 2rem;
      border-radius: 0.5rem;
      font-family: 'JetBrains Mono', monospace;
      font-weight: bold;
      font-size: 1.125rem;
      cursor: pointer;
      transition: all 0.2s;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    .cta-button:hover {
      text-shadow: 0 0 5px currentColor, 0 0 10px currentColor, 0 0 15px currentColor;
      transform: scale(1.05);
    }
  `;

  private handleClick() {
    AppAnalytics.getPlausible()?.trackEvent('cta_clicked', {
      props: {
        page: 'homepage',
        button: 'join_waitlist',
        location: this.source
      }
    });

    const emailModal = document.querySelector('email-modal');
    if (emailModal) {
      (emailModal as any).source = this.source;
      (emailModal as any).open = true;
      (emailModal as any).setAttribute('open', 'true');
      (emailModal as any).requestUpdate()
    }
    this.requestUpdate()
  }

  render() {
    return html`
      <button
        class="cta-button"
        @click=${this.handleClick}>
        <span>🚀</span>JOIN_WAITLIST
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'waitlist-cta': WaitlistCta;
  }
}
